// ----------------------------------------------------------------------

export enum FeatureFlag {
  ReportBuilder = 'report-builder',
  ReportDefinitions = 'report-definitions',
  CustomFields = 'custom-fields',
  AiInsights = 'ai-insights',
  CompanyDashboard = 'company-dashboard',
  CompanyPartners = 'company-partner',
  CompanyProjects = 'company-project',
  CompanyProjectActions = 'company-project-action',
  CompanyProjectCategory = 'company-project-category',
  CompanyRoleManagement = 'company-role-management',
  CompanyUserManagement = 'company-user-management',
  SupportTicket = 'support-ticket',
}

export type FeatureFlagKey = `${FeatureFlag}`;

export type FeatureFlagsContextType = {
  flags: Partial<Record<FeatureFlagKey, boolean>>;
  loading: boolean;
  error: unknown;
  refresh: () => void;
};
